<div class="text-right d-flex search-toggel" style="display:flex;width:100%;position:relative;">
  <button (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="toggle-arrow-btn btn"
          aria-controls="collapseBasic" style="margin-left:auto;" tooltip="Toggle Search" placement="left">
    <i class="fa fa-angle-up" aria-hidden="true"></i>
    <i class="fa fa-search" hidden aria-hidden="true"></i>
  </button>
</div>
<div class="advanced-search-inner" [collapse]="isCollapsed">
  <div class="form-group bigdiv location-auto-complete" [ngClass]="{'nosavesearchbtn' : !canShowsavedSearch}">
    <!--<input type="text" class="form-control" name="" placeholder="Search Address, Location" (keyup)="buildTags($event,1)" [(ngModel)]="searchCriteria.Address">-->
    <!--<ng2-completer (keydown)="onKeydown($event)" (keyup)="buildTags($event,1);onKeyUp($event)" class="form-control" [maxChars]="90" placeholder="Tenant, Address, City, State" [datasource]="propertyDataService" [(ngModel)]="searchCriteria.Address" (selected)="onPropertySelect($event)" [minSearchLength]="2" [matchClass]="'autocompleteMatchText'" [textNoResults]="'No Result Found'"></ng2-completer>-->
    <!--<ng-select (keydown)="onKeydown($event)" (keyup)="buildTags($event,1);onKeyUp($event)" [(ngModel)]="searchCriteria.Address" [items]="propertyDataService" class="form-control" placeholder="Tenant, Address, City, State" [searchable]="true" [virtualScroll]="true" [minTermLength]="2" (change)="onPropertySelect($event)" [textNoResults]="'No Result Found'"></ng-select>-->
    <mat-form-field class="mat-no-border select-highlight mobile-change-select matautocomplete">
      <input matInput
             placeholder="Search Tenants"
             [matAutocomplete]="auto"
             [(ngModel)]="searchCriteria.TenantAddressInput"
             (input)="dataServiceInput$.next($event.target.value);" />

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPropertySelect($event.option.value)">

        <ng-container *ngIf="dataService$ | async as items">
          <ng-container *ngIf="items.length > 0; else noResults">
            <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                        [value]="item">
              <div class="split-container">
                <span>{{ item.PropertyName }}</span>
                <span class="location-type">{{ item.Type }}</span>
              </div>
            </mat-option> 
          </ng-container>
        </ng-container>
        <ng-template #noResults>
          <mat-option disabled>
            No data available
          </mat-option>
        </ng-template>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div [class]="IsNull(searchCriteria.AssetTypes).length==0? 'form-group smalldiv' :'form-group smalldiv selected-div'">
    <div class="select-dropdown right-border multiselectdesign">
      <!--<mat-form-field class="mat-no-border select-highlight mobile-change-select">
    <mat-select panelClass="dynamic-width" [(ngModel)]="selectedAssetTypes" id="mySelect" class="propertylisting-search" placeholder="Property Type" (ngModelChange)="onModelChange(3);buildTags($event,3);bindSubCategoroes($event);" multiple>
      @if(selectedAssetTypes?.length > 1) {
      <mat-select-trigger>
        <span>{{ selectedAssetTypes.length }} items selected</span>
      </mat-select-trigger>
      }
      @for (asset of inputAssetTypes; track $index) {
      <mat-option [value]="asset" class="multi-dropdown-item">{{asset.itemName}}</mat-option>
      }
      <mat-option class="matoptionnodata" *ngIf="!inputAssetTypes?.length" disabled>
        No Data Available
      </mat-option>
    </mat-select>
  </mat-form-field>-->
      <mat-form-field class="mat-no-border select-highlight mobile-change-select property-type-form">
        <mat-label>Property Types</mat-label>
        <mat-select panelClass="dynamic-width" id="mySelect" class="propertylisting-search" multiple>
          <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="search-wrapper search-property-type">
            <mat-form-field class="no-bottom-border">
              <input matInput
                     placeholder="Search Property Types"
                     class="search-input" [(ngModel)]="searchPropertyType" (keyup)="onSearchChange()" />
            </mat-form-field>

          </div>
          <mat-optgroup *ngFor="let group of inputAssetTypes">
            <div>
              <mat-checkbox (click)="$event.stopPropagation()" [checked]="group.checked" (change)="toggleParent($event, group);" class="blue-checkbox">
                {{group.itemName}}
              </mat-checkbox>
              <span (click)="expandTypes(group)" class="btn-collapse" [class.span-open]="isExpandCategory[group.id]" *ngIf="group?.subCategory!=null&&group?.subCategory?.length>0">
                <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!isExpandCategory[group.id]"></i>
                <i class="fa fa-angle-up" aria-hidden="true" *ngIf="isExpandCategory[group.id]"></i>
              </span>
            </div>

            <mat-option *ngFor="let name of group?.subCategory" class="hide-mat-option child-option" [ngClass]="{'show':isExpandCategory[group.id],'list-hide':!isExpandCategory[group.id]}">
              <div class="child-row">
                <mat-checkbox (click)="$event.stopPropagation()"
                              [checked]="name?.checked"
                              (change)="togglechild($event, name)" class="blue-checkbox">
                  {{name?.name}}
                </mat-checkbox>
              </div>
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div [class]="IsNull(searchCriteria.PriceFrom)+IsNull(searchCriteria.PriceTo) =='' ? 'form-group smalldiv pricediv clearfix' :'form-group smalldiv pricediv clearfix selected-div'">
    <div class="btn-group select-dropdown clearfix right-border" dropdown>
      <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
        Price <span class="caret"></span>
      </button>
      <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
        <div class="form-group margin0">
          <div class="row">
            <div class="resp-col margin-bottom-15">
              <div class="textbox-with-btn-left">
                <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,2)" maxlength="15"
                       [(ngModel)]="searchCriteria.PriceFrom" placeholder="- Min -" />
                <span class="leftlabel">$</span>
              </div>
              <!--<span class="minusspan">-</span>-->
            </div>
            <div class="resp-col">
              <div class="textbox-with-btn-left">
                <input type="text" inputmode="numeric" (keydown)="onInputKeyPress($event)" class="search-field-input form-control"
                       (keyup)="buildTags($event,2)" maxlength="15" mask="separator.10" thousandSeparator=","
                       [(ngModel)]="searchCriteria.PriceTo" placeholder="- Max -" />
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div [class]="IsNull(searchCriteria.CapRateFrom)+IsNull(searchCriteria.CapRateTo) =='' ? 'form-group smalldiv pricediv clearfix' :'form-group smalldiv pricediv clearfix selected-div'">
    <div class="btn-group select-dropdown clearfix right-border" dropdown>
      <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
        Cap Rate <span class="caret"></span>
      </button>
      <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
        <div class="form-group margin0">
          <div class="row">
            <div class="resp-col margin-bottom-15">
              <div class="textbox-with-4character textbox-with-2character textbox-with-btn">
                <input inputmode="decimal" (keydown)="onInputKeyPress($event);onInputKeyPressevent($event)" type="text" class="search-field-input form-control"
                       mask="999.99" (keyup)="buildTags($event,11)" [dropSpecialCharacters]="false"
                       [(ngModel)]="searchCriteria.CapRateFrom"
                       placeholder="- Min -" (change)="validateFilters()">
                <span class="rightlabel">%</span>
              </div>
            </div>
            <div class="resp-col">
              <div class="textbox-with-4character  textbox-with-2character textbox-with-btn">
                <input inputmode="decimal" (keydown)="onInputKeyPress($event);onInputKeyPressevent($event)" type="text" class="search-field-input form-control"
                       [dropSpecialCharacters]="false" mask="999.99" (keyup)="buildTags($event,11)"
                       [(ngModel)]="searchCriteria.CapRateTo"
                       placeholder="- Max -" (change)="validateFilters()">
                <span class="rightlabel">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<div [class]="IsNull(searchCriteria.Ratings).length==0  ? 'form-group smalldiv' :'form-group smalldiv selected-div'">
    <div class="select-dropdown right-border multiselectdesign">
      <ss-multiselect-dropdown [options]="inputRatings" [(ngModel)]="searchCriteria.Ratings" (ngModelChange)="buildTags($event,4)" [settings]="defaultCreditSettings" [texts]="defaultCreditText"></ss-multiselect-dropdown>
    </div>
  </div>-->
  <!--<div [class]="IsNull(searchCriteria.Terms).length==0  ? 'form-group smalldiv' :'form-group smalldiv selected-div'">
      <div class="select-dropdown right-border multiselectdesign">
          <ss-multiselect-dropdown [options]="inputTerms" [(ngModel)]="searchCriteria.Terms" [settings]="defaultTermSettings" [texts]="defaultTermText"></ss-multiselect-dropdown>
      </div>
  </div>-->
  <div [class]="IsNull(searchCriteria.MinTerm)+IsNull(searchCriteria.MaxTerm) =='' ? 'form-group smalldiv pricediv clearfix' :'form-group smalldiv pricediv clearfix selected-div'">
    <div class="btn-group select-dropdown clearfix right-border" dropdown>
      <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
        Term <span class="caret"></span>
      </button>
      <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
        <div class="form-group margin0">
          <div class="row">
            <div class="resp-col margin-bottom-15">
              <div class="textbox-with-4character textbox-with-btn">
                <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" (keyup)="buildTags($event,5)" maxlength="15"
                       [(ngModel)]="searchCriteria.MinTerm" placeholder="- Min -" value="{{searchCriteria.MinTerm}}" />
                <span class="rightlabel">Years</span>
              </div>
            </div>
            <div class="resp-col">
              <div class="textbox-with-4character textbox-with-btn">
                <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" (keyup)="buildTags($event,5)" maxlength="15"
                       [(ngModel)]="searchCriteria.MaxTerm" placeholder="- Max -" value="{{searchCriteria.MaxTerm}}" />
                <span class="rightlabel">Years</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class]="IsNull(searchCriteria?.States).length==0? 'form-group smalldiv' :'form-group smalldiv selected-div'">
    <div class="form-group width100">
      <div class="select-dropdown right-border multiselectdesign">
        <mat-form-field class="select-highlight">
          <mat-select #dropdownState placeholder="State" [(ngModel)]="searchCriteria.States"
                      (ngModelChange)="buildTags($event, 9);addState()" multiple class="custom-arrow-select" panelClass="dynamic-width">
            @if (searchCriteria?.States?.length > 1) {
            <mat-select-trigger>
              <span>{{ searchCriteria?.States?.length }} items selected</span>
            </mat-select-trigger>
            }
            <mat-option>
              <ngx-mat-select-search #searchKey
                                     [hideClearSearchButton]="true"
                                     placeholderLabel="Search by state"
                                     noEntriesFoundLabel="Nothing found..."
                                     [enableClearOnEscapePressed]="true"
                                     (click)="$event.stopPropagation()">
              </ngx-mat-select-search>
            </mat-option>

            @for (state of inputStates | arraySearch : 'name' : searchKey.value; track $index) {
            <mat-option (click)="$event.stopPropagation()" [value]="state.id" class="multi-dropdown-item">
              {{state.name}}
            </mat-option>
            }

          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>


  <div [class]="(IsNull(searchCriteria.NOIFrom)+IsNull(searchCriteria.NOITo)+
               IsNull(searchCriteria.BuildingSizeFrom)+IsNull(searchCriteria.BuildingSizeTo)+
               IsNull(searchCriteria.YearBuiltFrom)+IsNull(searchCriteria.YearBuiltTo)+
               IsNull(searchCriteria.States)+IsNull(searchCriteria.LeaseStructures)+
               IsNull(searchCriteria.States)+IsNull(searchCriteria.CharacteristicsId)+
               IsNull(searchCriteria.CapRateFrom)+IsNull(searchCriteria.CapRateTo)+
               IsNull(searchCriteria.PropertyStatus)+IsNull(searchCriteria.SubCategories)+IsNull(searchCriteria.OwnershipTypes)+
               IsNull(searchCriteria.RentFrom)+IsNull(searchCriteria.RentTo)+
               IsChecked(searchCriteria.IsExcludeSoldListing)+IsChecked(searchCriteria.IsOnlySoldListing)+IsChecked(searchCriteria.IsExcludeContractListing)+IsChecked(searchCriteria.IsOnlyFeaturedListing)
               )  =='' ?  'form-group  advanced-filter-btn clearfix': 'form-group  advanced-filter-btn clearfix selected-div'">

    <div class="btn-group select-dropdown clearfix right-border">
      <button type="button" class="btn btn-default btn-advanced btn-border" area-expanded="true" (click)="openModalAdvanceFilter(AdvacnceFilterPopUp,'commonmodal be-advanced-filter-modal')">
        <i aria-hidden="true" class="icon-be-filter icon-solar"></i>
      </button>
    </div>
  </div>
  <button class="searchbtn" (click)="onPropertySearch();"
          [ngClass]="{'nosavesearchbtn' : !canShowsavedSearch}">
    Search
  </button>
  <a style="display:none" href="javascript:void(0);" *ngIf="canShowsavedSearch || authService.Broker()" tooltip="Save Search" triggers="mouseenter:mouseleave"
     (click)="openModal(template,'panlestyle')" class="btn-icon01" id="savesearch-modal"><i class="icon-save" aria-hidden="true"></i> Save</a>
  <a href="javascript:void(0);" *ngIf="authService.Admin()|| authService.SuperAdmin() || authService.Broker()" tooltip="Share Search" triggers="mouseenter:mouseleave"
     (click)="saveSearchLink()" class="btn-icon01"><i class="glyphicon glyphicon-share" aria-hidden="true"></i> Save</a>
  <a href="javascript:void(0);" tooltip="Reset Search" placement="left" class="btn-icon01" (click)="onResetClick();">
    <i class="icon-reset" aria-hidden="true"></i>Reset
  </a>
</div>
<div class="clearfix"></div>
<div [ngClass]="{'search-tag-box' : filterTags?.length > 0,'no-tags':filterTags?.length <= 0 }">
  <span class="be-tag" *ngFor="let tag of filterTags;let i = index">
    {{getFilterTagText(tag)}}<button type="button" class="tag-close"
                                     (click)="removeTag(tag.Id,1)">
      <span aria-hidden="true">&times;</span>
    </button>
  </span>
</div>
<ng-template #AdvacnceFilterPopUp>
  <div class="modal-header no-border"><h4 class="modal-title pull-left">Advanced Filters</h4><button type="button" aria-label="Close" class="close pull-right" (click)="modalRefAdvanceFilter.hide();setOrginalSearchCriteria();"><span aria-hidden="true">x</span></button></div>
  <div class="modal-body">
    <div>
      <div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <div class="be-input-border">
                  <h3 class="bluelabel margin-bottom-15">Lease</h3>
                  <div class="form-full-border">
                    <label class="form-label">Lease Structure</label>
                    <div [class]="IsNull(searchCriteria.LeaseStructures)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                      <div class="select-dropdown  multiselectdesign select-check">
                        <!-- <angular2-multiselect [data]="inputLeaseStructure" [(ngModel)]="searchCriteria.LeaseStructures" (ngModelChange)="buildTags($event,10);" [settings]="defaultLeaseStructureSettings"></angular2-multiselect> -->
                        <mat-form-field class="select-highlight">
                          <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.LeaseStructures"
                                      placeholder="- Select -" multiple>
                            @if (searchCriteria?.LeaseStructures?.length > 1) {
                            <mat-select-trigger>
                              <span>{{ searchCriteria?.LeaseStructures?.length }} items selected</span>
                            </mat-select-trigger>
                            }
                            @for (lease of inputLeaseStructure; track $index) {
                            <mat-option [value]="lease.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{lease.name}}</mat-option>
                            }
                            <mat-option class="matoptionnodata" *ngIf="!inputLeaseStructure?.length" disabled>
                              Nothing found...
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">NOI/Rent</label>
                  <div class="margin-bottom-20 row">
                    <div [class]="IsNull(searchCriteria.NOIFrom)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.NOIFrom"
                               placeholder="Min ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                      <!--<span class="minusspan">-</span>-->
                    </div>
                    <div [class]="IsNull(searchCriteria.NOITo)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.NOITo"
                               placeholder="Max ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                    </div>
                  </div>
                  <div *ngIf="(rentValidation!='')">
                    <p class="redtext">{{rentValidation}}</p>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">Tenants</label>
                  <mat-form-field class="select-highlight mobile-change-select matautocomplete">
                    <input matInput
                           placeholder="Search Tenants"
                           [matAutocomplete]="auto1"
                           [(ngModel)]="searchCriteria.TenantInput"
                           (input)="dataTenantServiceInput$.next($event.target.value);" />
                    <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayTenantFn" (optionSelected)="onTenantSelect($event.option.value)">
                      <ng-container *ngIf="dataTenantService$ | async as items">
                        <ng-container *ngIf="items.length > 0; else noTenantResults">
                          <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                                      [value]="item">
                            <div class="split-container">
                              <span>{{ item.PropertyName }}</span>
                            </div>
                          </mat-option>
                        </ng-container>
                      </ng-container>
                      <ng-template #noTenantResults>
                        <mat-option disabled>
                          No data available
                        </mat-option>
                      </ng-template>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-3">
                <h3 class="bluelabel margin-bottom-15">Rent Escalations</h3>
                <div class="be-input-border" style="min-height:74px;">
                  <label class="form-label">&nbsp;</label>
                  <div class="row form-radio">
                    <div class="col-md-4 col-sm-4 col-xs-6">
                      <label class="radio radio-inline">
                        <input name="radio" type="radio" #rdamount (change)="onRentEscalationChange(true)">
                        <i class="helper"></i>Amount
                      </label>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-6">
                      <label class="radio radio-inline margin-bottom-10">
                        <!--<input name="radio" type="radio" (change)="onRentEscalationChange(false)">-->
                        <input name="radio" type="radio" #rdpercentage checked
                               (change)="onRentEscalationChange(false)" />
                        <i class="helper"></i>Percentage
                      </label>
                    </div>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">{{rdamount.checked ? 'Amount($)':'Percentage(%)'}}</label>
                  <div class="margin-bottom-20 row" *ngIf="rdamount.checked">
                    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.RentFrom"
                               placeholder="Min ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                      <!--<span class="minusspan">-</span>-->
                    </div>
                    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.RentTo"
                               placeholder="Max ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                    </div>
                  </div>
                  <div class="margin-bottom-20 row" *ngIf="rdpercentage.checked">
                    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn textbox-with-2character">
                        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               [dropSpecialCharacters]="false" mask="999.99"
                               [(ngModel)]="searchCriteria.RentFrom" placeholder="Min (%)"
                               (change)="validateFilters()">
                        <!--<span class="rightlabel">%</span>-->
                      </div>
                      <!--<span class="minusspan">-</span>-->
                    </div>
                    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn textbox-with-2character">
                        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               [dropSpecialCharacters]="false" mask="999.99"
                               [(ngModel)]="searchCriteria.RentTo" placeholder="Max (%)"
                               (change)="validateFilters()">
                        <!--<span class="rightlabel">%</span>-->
                      </div>
                    </div>
                  </div>
                  <div *ngIf="(rentescalationValidation!='')">
                    <p class="redtext">{{rentescalationValidation}}</p>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">Tenant Credit</label>
                  <mat-form-field class="select-highlight">
                    <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.Ratings"
                                placeholder="- Select -" multiple>

                      @if (searchCriteria?.Ratings?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria?.Ratings.length }} items selected</span>
                      </mat-select-trigger>
                      }

                      @for (rate of inputRatings; track $index) {
                      <mat-option [value]="rate.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{rate.name}}</mat-option>
                      }
                      <mat-option class="matoptionnodata" *ngIf="!inputRatings?.length" disabled>
                        Nothing found...
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-5">
                <h3 class="bluelabel margin-bottom-15">Building</h3>
                <div class="row">
                  <div class="col-md-7">
                    <div class="be-input-border">
                      <label class="form-label">Year Built</label>
                      <div class="margin-bottom-20 row">
                        <div [class]="IsNull(searchCriteria.YearBuiltFrom)==''? 'resp-col' : 'resp-col activated'">
                          <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 mask="9999" id="txtYearBuiltFrom" [(ngModel)]="searchCriteria.YearBuiltFrom"
                                 value="{{searchCriteria.YearBuiltFrom}}" placeholder="- From -"
                                 maxlength="4">
                          <span class="minusspan">-</span>
                        </div>
                        <div [class]="IsNull(searchCriteria.YearBuiltTo)==''? 'resp-col' : 'resp-col activated'">
                          <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 mask="9999" id="txtYearBuiltTo" [(ngModel)]="searchCriteria.YearBuiltTo"
                                 value="{{searchCriteria.YearBuiltTo}}" placeholder="- To -"
                                 maxlength="4">
                        </div>
                      </div>
                      <div *ngIf="(yearbuiltValidation!='')">
                        <p class="redtext">{{yearbuiltValidation}}</p>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Characteristics</label>
                    <div [class]="IsNull(searchCriteria.CharacteristicsId)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                      <div class="select-dropdown  multiselectdesign select-check">
                        <!-- <angular2-multiselect [data]="characteristicList" [(ngModel)]="searchCriteria.CharacteristicsId" (ngModelChange)="buildTags($event,19);" [settings]="defaultCharacteristicsSettings"></angular2-multiselect> -->
                        <mat-form-field class="select-highlight">
                          <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.CharacteristicsId"
                                      placeholder="- Select -" multiple>

                            @if(searchCriteria?.CharacteristicsId?.length > 1) {
                            <mat-select-trigger>
                              <span>{{ searchCriteria?.CharacteristicsId?.length }} items selected</span>
                            </mat-select-trigger>
                            }

                            @for (list of characteristicList; track $index) {
                            <mat-option [value]="list.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{list.name}}</mat-option>
                            }
                            <mat-option class="matoptionnodata" *ngIf="!characteristicList?.length" disabled>
                              Nothing found...
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-7">
                    <label class="form-label">Building Size (Sq.Ft)</label>
                    <div class="margin-bottom-20 row">
                      <div [class]="IsNull(searchCriteria.BuildingSizeFrom)==''? 'resp-col' : 'resp-col activated'">
                        <div class="textbox-with-btn sfstyle be-input-border">
                          <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 [dropSpecialCharacters]="false" thousandSeparator="," mask="999999999999999999999.99"
                                 [(ngModel)]="searchCriteria.BuildingSizeFrom" placeholder="Min"
                                 (change)="validateFilters()">
                          <!--<span class="rightlabel">SF</span>-->
                        </div>
                        <!--<span class="minusspan">-</span>-->
                      </div>
                      <div [class]="IsNull(searchCriteria.BuildingSizeTo)==''? 'resp-col' : 'resp-col activated'">
                        <div class="textbox-with-btn sfstyle be-input-border">
                          <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 [dropSpecialCharacters]="false" thousandSeparator="," mask="999999999999999999999.99"
                                 [(ngModel)]="searchCriteria.BuildingSizeTo"
                                 placeholder="Max" (change)="validateFilters()">
                          <!--<span class="rightlabel">SF</span>-->
                        </div>
                      </div>
                    </div>
                    <div *ngIf="(buildsizeValidation!='')">
                      <p class="redtext">{{buildsizeValidation}}</p>
                    </div>
                  </div>

                </div>
              </div>

              <!----start-->
              <div class="col-md-12 margin-bottom-15 cf" *ngIf="tenantFilterTags && tenantFilterTags.length > 0">
                <div class="search-tag-box margin0">
                  <span class="be-tag" *ngFor="let tag of tenantFilterTags;let i = index">
                    {{tag.Value}}<button type="button" class="tag-close"
                                         (click)="removeTenantTag(tag)">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </span>
                </div>
              </div>
              <!----end-->

              <div class="col-md-12">
                <div class="border-sep cf" style="border-top: 1px solid #DCE0E4"></div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h3 class="bluelabel margin-bottom-15 margin-top-15">Location</h3>
                <div class="row">
                  <div class="col-md-6" *ngIf="authService.Admin()||authService.SuperAdmin()||authService.Broker()">
                    <div class="be-input-border">
                      <label class="form-label">Address</label>
                      <mat-form-field class="select-highlight mobile-change-select matautocomplete">
                        <input matInput
                               placeholder="Search Address"
                               [matAutocomplete]="auto2"
                               [(ngModel)]="searchCriteria.TenantFullAdressInput"
                               (input)="AddressServiceInput$.next($event.target.value);" (ngModelChange)="onAddressInputChange($event)" />
                        <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onAddressSelect($event.option.value)">
                          <ng-container *ngIf="AddressService$ | async as items">
                            <ng-container *ngIf="items.length > 0; else noAddressResults">
                              <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                                          [value]="item">
                                <div class="split-container">
                                  <span>{{ item.PropertyName }}</span>
                                </div>
                              </mat-option>
                            </ng-container>
                          </ng-container>

                          <ng-template #noAddressResults>
                            <mat-option disabled>
                              No data available
                            </mat-option>
                          </ng-template>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="be-input-border">
                      <label class="form-label">State</label>
                      <div class="form-group">
                        <div [class]="IsNull(searchCriteria.AdvanceFilterStates)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                          <mat-form-field class="select-highlight">
                            <mat-select #dropdownState placeholder="- Select -" [(ngModel)]="searchCriteria.AdvanceFilterStates"
                                        (ngModelChange)="dropdownStateClose($event); bindCity(searchCriteria?.AdvanceFilterStates)" multiple panelClass="dynamic-width">
                              @if (searchCriteria?.AdvanceFilterStates?.length > 1) {
                              <mat-select-trigger>
                                <span>{{ searchCriteria?.AdvanceFilterStates?.length }} items selected</span>
                              </mat-select-trigger>
                              }
                              <mat-option>
                                <ngx-mat-select-search #searchKey
                                                       [hideClearSearchButton]="true"
                                                       placeholderLabel="Search by state"
                                                       noEntriesFoundLabel="Nothing found..."
                                                       [enableClearOnEscapePressed]="true"
                                                       (click)="$event.stopPropagation()">
                                </ngx-mat-select-search>
                              </mat-option>

                              @for (state of inputStates | arraySearch : 'name' : searchKey.value; track $index) {
                              <mat-option (click)="$event.stopPropagation()" [value]="state.id" class="multi-dropdown-item">
                                {{state.name}}
                              </mat-option>
                              }

                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="be-input-border">
                      <label class="form-label">City</label>
                      <div class="form-group">
                        <div [class]="IsNull(searchCriteria.CityId)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                          <label class="select">
                            <select [(ngModel)]="searchCriteria.CityId" class="form-control" [ngClass]="{'placeholder': !searchCriteria.CityId}" (click)="checkState()">
                              <option [ngValue]="null">- Select -</option>
                              <option *ngFor="let city of citiesList" [(ngValue)]="city.Id">{{city.Name}}</option>
                            </select>
                            <i></i>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf="authService.Admin()||authService.SuperAdmin()||authService.Broker()">
                    <label class="form-label">Property Id</label>
                    <div class="form-group be-input-border">
                      <div>
                        <div>
                          <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 id="txtPropertySequenceId" [(ngModel)]="searchCriteria.PropertySequenceId"
                                 value="{{searchCriteria.PropertySequenceId}}"
                                 placeholder="Property Id" maxlength="40">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <h3 class="bluelabel margin-bottom-15 margin-top-15">Listing Attributes</h3>
                <div class="row">
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="be-input-border">
                          <label class="form-label">Property Status</label>
                          <div class="form-group margin-bottom-20">
                            <div [class]="IsNull(searchCriteria.PropertyStatus)==''? 'select-dropdown r multiselectdesign select-check' : 'select-dropdown r multiselectdesign select-check activated'">
                              <mat-form-field class="select-highlight">
                                <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.PropertyStatus"
                                            placeholder="- Select -" multiple>
                                  @if(searchCriteria?.PropertyStatus?.length > 1) {
                                  <mat-select-trigger>
                                    <span>{{ searchCriteria?.PropertyStatus?.length }} items selected</span>
                                  </mat-select-trigger>
                                  }

                                  @for (property of inputPropertyStatus; track $index) {
                                  <mat-option [value]="property.id"
                                              (click)="$event.stopPropagation()" class="multi-dropdown-item">{{property.name}}</mat-option>
                                  }
                                  <mat-option class="matoptionnodata" *ngIf="!inputPropertyStatus?.length" disabled>
                                    Nothing found...
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="be-input-border">
                          <label class="form-label">Ownership Structure</label>
                          <div class="form-group margin-bottom-20">
                            <div [class]="IsNull(searchCriteria.OwnershipTypes)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                              <mat-form-field class="select-highlight">
                                <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.OwnershipTypes"
                                            placeholder="- Select -" multiple>
                                  @if(searchCriteria?.OwnershipTypes?.length > 1) {
                                  <mat-select-trigger>
                                    <span>{{ searchCriteria?.OwnershipTypes?.length }} items selected</span>
                                  </mat-select-trigger>
                                  }
                                  @for (owner of inputOwnershipStructure; track $index) {
                                  <mat-option [value]="owner.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{owner.name}}</mat-option>
                                  }
                                  <mat-option class="matoptionnodata" *ngIf="!inputOwnershipStructure?.length" disabled>
                                    Nothing found...
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-5">
                    <label class="form-label"></label>
                    <div class="search-check-box d-flex margin-top-40">
                      <label class="custom-checkbox">
                        <input type="checkbox"
                               [(ngModel)]="searchCriteria.IsPortfolio" />
                        <i class="helper"></i>Show Only Portfolios
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>
          <div class="d-flex">
            <div class="d-inline-flex ml-auto align-items-center" style="padding-right:15px">
              <button class="btn-link margin-right-15" (click)="onResetAdvanceFilterClick();onApplyFilterClick(false);">Clear All</button>
              <button class="btn btn-success btn-lg" (click)="onApplyFilterClick(true)">Apply</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #template class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Save Search</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">Name<span class="red">*</span></label>
      <input class="form-control" [(ngModel)]="saveSearchInputModel.SearchName" required type="text">
    </div>

    <div class="text-right">
      <button class="btn btn-default btn-lg" (click)="modalRef.hide();">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="saveSearch();">Save</button>
    </div>
    <br />
    <div class="form-group">
      <ul class="interesttags margin-bottom-15">
        <li *ngFor="let tag of filterTags">
          {{getFilterTagText(tag)}}<span class="icon-close icon" tooltip="remove" placement="top"
                                         (click)="removeTag(tag.Id,1)"></span>
        </li>
      </ul>
    </div>
  </div>

</ng-template>
<a id="copyurlhref" href="javascript:void(0);"
   style="text-align: unset !important;display:none;color: rgb(17,85,204) !important; text-decoration-line: underline;font-size: 13px !important; font-family: Poppins,sans-serif !important;">
</a>


<!--<div *dropdownMenu class="dropdown-menu dropdown-div mega-dropdown dropdown-menu-right" (click)="$event.stopPropagation()">
<div>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-12">
          <label class="form-label">NOI/Rent</label>
          <div class="margin-bottom-20 row">
            <div [class]="IsNull(searchCriteria.NOIFrom)==''? 'resp-col' : 'resp-col activated'">
              <div class="textbox-with-btn-left">
                <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,6)" [(ngModel)]="searchCriteria.NOIFrom"
                       placeholder="- Min -" maxlength="15"
                       (change)="validateFilters()">
                <span class="leftlabel">$</span>
              </div>
              <span class="minusspan">-</span>
            </div>
            <div [class]="IsNull(searchCriteria.NOITo)==''? 'resp-col' : 'resp-col activated'">
              <div class="textbox-with-btn-left">
                <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,6)" [(ngModel)]="searchCriteria.NOITo"
                       placeholder="- Max -" maxlength="15"
                       (change)="validateFilters()">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
          <div *ngIf="(rentValidation!='')">
            <p class="redtext">{{rentValidation}}</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <label class="form-label">Building Size</label>
          <div class="margin-bottom-20 row">
            <div [class]="IsNull(searchCriteria.BuildingSizeFrom)==''? 'resp-col' : 'resp-col activated'">
              <div class="textbox-with-btn sfstyle">
                <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       [dropSpecialCharacters]="false" (keyup)="buildTags($event,7)" thousandSeparator="," mask="999999999999999999999.99"
                       [(ngModel)]="searchCriteria.BuildingSizeFrom" placeholder="- Min -"
                       (change)="validateFilters()">
                <span class="rightlabel">SF</span>
              </div>
              <span class="minusspan">-</span>
            </div>
            <div [class]="IsNull(searchCriteria.BuildingSizeTo)==''? 'resp-col' : 'resp-col activated'">
              <div class="textbox-with-btn sfstyle">
                <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       [dropSpecialCharacters]="false" (keyup)="buildTags($event,7)" thousandSeparator="," mask="999999999999999999999.99"
                       [(ngModel)]="searchCriteria.BuildingSizeTo"
                       placeholder="- Max -" (change)="validateFilters()">
                <span class="rightlabel">SF</span>
              </div>
            </div>
          </div>
          <div *ngIf="(buildsizeValidation!='')">
            <p class="redtext">{{buildsizeValidation}}</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <label class="form-label">Year Built</label>
          <div class="margin-bottom-20 row">
            <div [class]="IsNull(searchCriteria.YearBuiltFrom)==''? 'resp-col' : 'resp-col activated'">
              <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                     mask="9999" id="txtYearBuiltFrom" [(ngModel)]="searchCriteria.YearBuiltFrom"
                     value="{{searchCriteria.YearBuiltFrom}}" (keyup)="buildTags($event,8)" placeholder="- From -"
                     maxlength="4">
              <span class="minusspan">-</span>
            </div>
            <div [class]="IsNull(searchCriteria.YearBuiltTo)==''? 'resp-col' : 'resp-col activated'">
              <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                     mask="9999" id="txtYearBuiltTo" [(ngModel)]="searchCriteria.YearBuiltTo"
                     value="{{searchCriteria.YearBuiltTo}}" (keyup)="buildTags($event,8)" placeholder="- To -"
                     maxlength="4">
            </div>
          </div>
          <div *ngIf="(yearbuiltValidation!='')">
            <p class="redtext">{{yearbuiltValidation}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-12">
          <label class="form-label">Property Id</label>
          <div class="form-group margin-bottom-20">
            <div>
              <div [class]="IsNull(searchCriteria.States)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                       id="txtPropertySequenceId" [(ngModel)]="searchCriteria.PropertySequenceId"
                       value="{{searchCriteria.PropertySequenceId}}" (keyup)="buildTags($event,21)"
                       placeholder="Property Id" maxlength="40">
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <label class="form-label">State</label>
          <div class="form-group margin-bottom-20">
            <div [class]="IsNull(searchCriteria.States)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">-->
<!-- <angular2-multiselect [data]="inputStates" [(ngModel)]="searchCriteria.States" [settings]="defaultStateSettings"
#dropdownState (ngModelChange)="dropdownStateClose($event);buildTags($event,9);"></angular2-multiselect> -->
<!--<mat-form-field class="select-highlight">
        <mat-select #dropdownState placeholder="- Select -" [(ngModel)]="searchCriteria.States"
                    (ngModelChange)="dropdownStateClose($event); buildTags($event, 9);" multiple>
          @if (searchCriteria?.States?.length > 1) {
          <mat-select-trigger>
            <span>{{ searchCriteria?.States?.length }} items selected</span>
          </mat-select-trigger>
          }
          <mat-option>
            <ngx-mat-select-search #searchKey
                                   [hideClearSearchButton]="true"
                                   placeholderLabel="Search by state"
                                   noEntriesFoundLabel="Nothing found..."
                                   [enableClearOnEscapePressed]="true"
                                   (click)="$event.stopPropagation()">
            </ngx-mat-select-search>
          </mat-option>

          @for (state of inputStates | arraySearch : 'name' : searchKey.value; track $index) {
          <mat-option (click)="$event.stopPropagation()" [value]="state.id" class="multi-dropdown-item">
            {{state.name}}
          </mat-option>
          }

        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="col-md-4 col-sm-4 col-xs-12">
  <label class="form-label">Lease Structure</label>
  <div [class]="IsNull(searchCriteria.LeaseStructures)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
    <div class="select-dropdown  multiselectdesign select-check">-->
<!-- <angular2-multiselect [data]="inputLeaseStructure" [(ngModel)]="searchCriteria.LeaseStructures" (ngModelChange)="buildTags($event,10);" [settings]="defaultLeaseStructureSettings"></angular2-multiselect> -->
<!--<mat-form-field class="select-highlight">
            <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.LeaseStructures"
                        placeholder="- Select -" (ngModelChange)="buildTags($event,10);" multiple>
              @if (searchCriteria?.LeaseStructures?.length > 1) {
              <mat-select-trigger>
                <span>{{ searchCriteria?.LeaseStructures?.length }} items selected</span>
              </mat-select-trigger>
              }
              @for (lease of inputLeaseStructure; track $index) {
              <mat-option [value]="lease.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{lease.name}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="!inputLeaseStructure?.length" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-md-12">
  <div class="row">
    <div class="col-md-4 col-sm-4 col-xs-12">
      <label class="form-label">Rating</label>
      <div [class]="IsNull(searchCriteria.Ratings).length==0  ? 'select-dropdown  multiselectdesign select-check' :'select-dropdown  multiselectdesign select-check activated'">
        <div class="select-dropdown  multiselectdesign select-check">-->
<!-- <angular2-multiselect [data]="inputRatings" [(ngModel)]="searchCriteria.Ratings" (ngModelChange)="buildTags($event,4)" [settings]="defaultCreditSettings"></angular2-multiselect> -->
<!--<mat-form-field class="select-highlight">
        <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.Ratings"
                    placeholder="- Select -" (ngModelChange)="buildTags($event,4)" multiple>

          @if (searchCriteria?.Ratings?.length > 1) {
          <mat-select-trigger>
            <span>{{ searchCriteria?.Ratings.length }} items selected</span>
          </mat-select-trigger>
          }

          @for (rate of inputRatings; track $index) {
          <mat-option [value]="rate.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{rate.name}}</mat-option>
          }
          <mat-option class="matoptionnodata" *ngIf="!inputRatings?.length" disabled>
            Nothing found...
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="col-md-4 col-sm-4 col-xs-12">
  <label class="form-label">Property Status</label>
  <div class="form-group margin-bottom-20">
    <div [class]="IsNull(searchCriteria.PropertyStatus)==''? 'select-dropdown r multiselectdesign select-check' : 'select-dropdown r multiselectdesign select-check activated'">-->
<!-- <angular2-multiselect [data]="inputPropertyStatus" [(ngModel)]="searchCriteria.PropertyStatus" (ngModelChange)="buildTags($event,12);" [settings]="defaultPropertyStatusSettings"></angular2-multiselect> -->
<!--<mat-form-field class="select-highlight">
        <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.PropertyStatus"
                    placeholder="- Select -" (ngModelChange)="buildTags($event,12)" multiple>
          @if(searchCriteria?.PropertyStatus?.length > 1) {
          <mat-select-trigger>
            <span>{{ searchCriteria?.PropertyStatus?.length }} items selected</span>
          </mat-select-trigger>
          }

          @for (property of inputPropertyStatus; track $index) {
          <mat-option [value]="property.id"
                      (click)="$event.stopPropagation()" class="multi-dropdown-item">{{property.name}}</mat-option>
          }
          <mat-option class="matoptionnodata" *ngIf="!inputPropertyStatus?.length" disabled>
            Nothing found...
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="col-md-4 col-sm-4 col-xs-12">
  <label class="form-label">Subcategory</label>
  <div class="form-group margin-bottom-20">
    <div [class]="IsNull(searchCriteria.SubCategories)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">-->
<!-- <angular2-multiselect [data]="inputSubCategory" [(ngModel)]="searchCriteria.SubCategories" (ngModelChange)="buildTags($event,13);" [settings]="defaultSubCategorySettings"></angular2-multiselect> -->
<!--<mat-form-field class="select-highlight">
            <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.SubCategories"
                        placeholder="- Select -" (ngModelChange)="buildTags($event,13);" multiple>

              @if(searchCriteria?.SubCategories?.length > 1) {
              <mat-select-trigger>
                <span>{{ searchCriteria?.SubCategories?.length }} items selected</span>
              </mat-select-trigger>
              }

              @for (category of inputSubCategory; track $index) {
              <mat-option [value]="category.id"
                          (click)="$event.stopPropagation()" class="multi-dropdown-item">{{category.name}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="!inputSubCategory?.length" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-md-12">
  <div class="row">
    <div class="col-md-4 col-sm-4 col-xs-12">
      <label class="form-label mt-35-xl">Ownership Structure</label>
      <div class="form-group margin-bottom-20">
        <div [class]="IsNull(searchCriteria.OwnershipTypes)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">-->
<!-- <angular2-multiselect [data]="inputOwnershipStructure" [(ngModel)]="searchCriteria.OwnershipTypes" (ngModelChange)="buildTags($event,14);" [settings]="defaultOwnershipStructureSettings"></angular2-multiselect> -->
<!--<mat-form-field class="select-highlight">
        <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.OwnershipTypes"
                    placeholder="- Select -" (ngModelChange)="buildTags($event,14)" multiple>
          @if(searchCriteria?.OwnershipTypes?.length > 1) {
          <mat-select-trigger>
            <span>{{ searchCriteria?.OwnershipTypes?.length }} items selected</span>
          </mat-select-trigger>
          }
          @for (owner of inputOwnershipStructure; track $index) {
          <mat-option [value]="owner.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{owner.name}}</mat-option>
          }
          <mat-option class="matoptionnodata" *ngIf="!inputOwnershipStructure?.length" disabled>
            Nothing found...
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="col-md-4 col-sm-4 col-xs-12">
  <label class="form-label">Rent Escalation</label>

  <div class="row form-radio">
    <div class="col-md-6 col-sm-6 col-xs-6">
      <label class="radio radio-inline">
        <input name="radio" type="radio" #rdamount (change)="onRentEscalationChange(true)">
        <i class="helper"></i>Amount
      </label>
    </div>
    <div class="col-md-6 col-sm-6 col-xs-6">
      <label class="radio radio-inline margin-bottom-10">-->
<!--<input name="radio" type="radio" (change)="onRentEscalationChange(false)">-->
<!--<input name="radio" type="radio" #rdpercentage checked
               (change)="onRentEscalationChange(false)" />
        <i class="helper"></i>Percentage
      </label>
    </div>
  </div>
  <div class="margin-bottom-20 row" *ngIf="rdamount.checked">
    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn-left">
        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
               mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,15);" [(ngModel)]="searchCriteria.RentFrom"
               placeholder="- Min -" maxlength="15"
               (change)="validateFilters()">
        <span class="leftlabel">$</span>
      </div>
      <span class="minusspan">-</span>
    </div>
    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn-left">
        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
               mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,15);" [(ngModel)]="searchCriteria.RentTo"
               placeholder="- Max -" maxlength="15"
               (change)="validateFilters()">
        <span class="leftlabel">$</span>
      </div>
    </div>
  </div>
  <div class="margin-bottom-20 row" *ngIf="rdpercentage.checked">
    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn textbox-with-2character">
        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
               [dropSpecialCharacters]="false" mask="999.99" (keyup)="buildTags($event,15);"
               [(ngModel)]="searchCriteria.RentFrom" placeholder="- Min -"
               (change)="validateFilters()">
        <span class="rightlabel">%</span>
      </div>
      <span class="minusspan">-</span>
    </div>
    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn textbox-with-2character">
        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
               [dropSpecialCharacters]="false" mask="999.99" (keyup)="buildTags($event,15);"
               [(ngModel)]="searchCriteria.RentTo" placeholder="- Max -"
               (change)="validateFilters()">
        <span class="rightlabel">%</span>
      </div>
    </div>
  </div>
  <div *ngIf="(rentescalationValidation!='')">
    <p class="redtext">{{rentescalationValidation}}</p>
  </div>
</div>
<div class="col-md-4 col-sm-4 col-xs-12">
  <label class="form-label mt-35-xl">Property Characteristics</label>
  <div [class]="IsNull(searchCriteria.CharacteristicsId)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
    <div class="select-dropdown  multiselectdesign select-check">-->
<!-- <angular2-multiselect [data]="characteristicList" [(ngModel)]="searchCriteria.CharacteristicsId" (ngModelChange)="buildTags($event,19);" [settings]="defaultCharacteristicsSettings"></angular2-multiselect> -->
<!--<mat-form-field class="select-highlight">
        <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.CharacteristicsId"
                    placeholder="- Select -" (ngModelChange)="buildTags($event,19);" multiple>

          @if(searchCriteria?.CharacteristicsId?.length > 1) {
          <mat-select-trigger>
            <span>{{ searchCriteria?.CharacteristicsId?.length }} items selected</span>
          </mat-select-trigger>
          }

          @for (list of characteristicList; track $index) {
          <mat-option [value]="list.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{list.name}}</mat-option>
          }
          <mat-option class="matoptionnodata" *ngIf="!characteristicList?.length" disabled>
            Nothing found...
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>-->
<!--<div class="col-md-4 col-sm-4 col-xs-12">
    <div class="margin-bottom-20">
        <label class="custom-checkbox" [ngStyle]="{'opacity':searchCriteria.IsExcludeSoldListing ? '0.5' : '1' }">
            <input type="checkbox" [(ngModel)]="searchCriteria.IsOnlySoldListing" [disabled]="searchCriteria.IsExcludeSoldListing" />
            <i class="helper"></i>Show only sold listings
        </label>
    </div>
</div>

<div class="col-md-4 col-sm-4 col-xs-12">
    <div class="margin-bottom-20">
        <label class="custom-checkbox ">
            <input type="checkbox" [(ngModel)]="searchCriteria.IsOnlyFeaturedListing" />
            <i class="helper"></i>Show only featured listing
        </label>
    </div>
</div>-->
<!--</div>
      </div>

      <div class="col-md-12">
        <div class="cf">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="row margin-top-15">
              <div class="search-check-box d-flex">
                <label class="custom-checkbox"
                       [ngStyle]="{'opacity':searchCriteria.IsOnlySoldListing ? '0.5' : '1' }">
                  <input type="checkbox" [(ngModel)]="searchCriteria.IsExcludeSoldListing"
                         (change)="buildTags($event,16);" [disabled]="searchCriteria.IsOnlySoldListing" />
                  <i class="helper"></i>Exclude sold listings
                </label>
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="buildTags($event,17);"
                         [(ngModel)]="searchCriteria.IsExcludeContractListing" />
                  <i class="helper"></i>Exclude listings under contract
                </label>
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="buildTags($event,20);"
                         [(ngModel)]="searchCriteria.IsPortfolio" />
                  <i class="helper"></i>Show Only Portfolios
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 margin-top-15 cf">
          <button class="underline-link" (click)="onResetFilterClick();;dropdown.hide()"
                  style="margin-top:0 !important">
            Reset
          </button>
        </div>
      </div>

    </div>
  </div>
</div>-->
